export function stripNewlines(text: string): string {
  return text.replace(/[\r\n]+/gm, "");
}
